<template>
  <div styleName="content_micro_wp">
    <div styleName="content_micro">
      <div styleName="content_micro_left">
        <label>{{ $t('selectMicrophone') }}
          <span styleName="content_hardware_mix">
            (<input type="checkbox" name="hardware_mix" v-model="selectedMixState" /> {{$t('hardwareMixing')}})
          </span>
        </label>
        <select :value="changedAudioDeviceIndex" @change="changeMicroDevice">
          <option v-for="(audio,index) in audioList" :value="index" :key="audio.deviceId">
            {{audio.label || $t('microphone') + ' ' + (index + 1)}}
          </option>
        </select>
        <label styleName="content_micro_volume_label">{{ $t('volume') }}
          <i v-show="/zh/.test($i18n.locale)">（建议不超过80%，否则会出现爆音）</i>
        </label>
        <div styleName="content_micro_volume_wp">
          <div styleName="content_micro_volume_range">
            <input type="range" @input="changeVolume" v-model="volume" :style="volumeRangeStyle" />
          </div>
          <span styleName="content_micro_volume_value">{{volume}}%</span>
        </div>
        <div styleName="content_micro_dynamic_visualization">
          <div styleName="content_micro_volume_unit" :data-role="unit < realTimeVolume ? 'active':''" v-for="(unit, index) in audioBufferArr" :key="index">
          </div>
        </div>
        <div styleName="content_micro_volume_tip">
          <span styleName="checked_icon" :data-checked="isAudioDetect"></span>
          <p>{{isAudioDetect ? $t('detectedVoice') : $t('failDetectingVoice')}}</p>
        </div>
      </div>
      <div styleName="content_micro_right">
        <h4>{{ $t('question') }}:</h4>
        <p>{{ $t('solveVoiceProblem') }}</p>
      </div>
    </div>
    <!-- <FooterButton @confirm="_confirm" /> -->
    <div styleName="content_footer">
      <button @click="_confirm" data-role="active">{{ $t('confirm') }}</button>
    </div>
  </div>
</template>

<script>
import styles from './index.scss'
import cssModules from 'vue-css-modules'
import { mapGetters } from 'vuex'
import * as types from '../../constants'


export default {
  name: 'micro',
  mixins: [cssModules(styles)],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      realTimeVolume: 0, // 实时音量
      audioBufferArr: [],
      volume: 0, // 音量调节进度条的值
      gainNode: null, // 音量控制节点
      context: null, // audio处理上下文
      // isAudioDetect: false, // 是否检测到声音
      tempAudioIndex: 0,
      localStream: null, // 本地音视频流
      changingAudioDevice: false, // 更改麦克风设备
      levelChecker: null, // 音量分析器
      isMixClose: false,
      selectedMixState: false  // 选择混音状态
    }
  },
  computed: {
    ...mapGetters(['audioStatus', 'audioSettingVolume', 'deviceLists', 'roomDetail', 'alertStatus', 'hasPublished']),
    audioList () {
      return this.deviceLists.audioList
    },
    // 默认麦克风
    selectedAudioDeviceIndex () {
      return this.$store.state.mediaInfo.selectedDevice.audio
    },
    // 更改后的音频设备
    changedAudioDeviceIndex () {
      return this.changingAudioDevice ? this.tempAudioIndex : this.selectedAudioDeviceIndex
    },
    volumeRangeStyle () {
      return `background: linear-gradient(to right, rgba(134, 196, 64, 1), rgba(134, 196, 64, 1) ${this.volume}%, rgba(226, 222, 221, 1) ${+this.volume + 1}%, rgba(226, 222, 221, 1))`
    },
    isAudioDetect () {
      return this.localStream && this.audioStatus && this.volume > 0
    }
  },
  watch: {
    alertStatus (newVal) {
      if (newVal) return
      this._resume()
    },
    audioStatus () {
      this.initVolume()
    },
    show (flag) {
      if (flag) return
      this._resume()
    }
  },
  mounted () {
    this.isMixClose = this.$store.state.audioInfo.isMixClose
    this.getAudioBufferArr()
    this.getUserMedia()
    this.selectedMixState = this.isMixClose
  },
  methods: {
    initVolume () {
      if (!this.audioStatus) {
        this.setMute()
      } else {
        this.volume = this.audioSettingVolume
      }
      this.changeVolume()
    },
    setMute () {
      this.volume = 0
      this.gainNode.gain.setValueAtTime(0, this.context.currentTime) // 静音
    },
    getAudioBufferArr () {
      for (let i = 0; i < 40; i++) {
        this.audioBufferArr.push(i * 2.5)
      }
    },
    getUserMedia () {
      // 解决旧浏览器的兼容性问题
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          let getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia
          if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
          }
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      if (navigator.mediaDevices.getUserMedia) {
        let { deviceId } = this.audioList[this.changedAudioDeviceIndex]
        let contraints = {
          audio: { deviceId: { exact: deviceId } }
        }
        console.log('contraints', contraints)
        navigator.mediaDevices.getUserMedia(contraints)
          .then(mediaStream => {
            // 对音频进行处理
            // todo:当前agora web sdk不提供音量控制API
            this.localStream = mediaStream // 存储本地流便于后续操作
            this.handleAudioStream(mediaStream)
          }).catch((error) => {
            this.$toast.show({
              text: error,
              headerDesc: this.$t('attention'),
              buttonCount: 1,
              textStyle: {
                textAlign: 'center'
              },
              btnText: this.$t('btnok'),
              btnOK: () => {
                window.location.reload()
              }
            })
          })
      } else {
        console.log('您的浏览器不支持获取音频')
      }
    },
    handleAudioStream (stream) {
      let AudioContext = window.AudioContext || window.webkitAudioContext
      let context = new AudioContext() // 创建一个管理、播放声音的对象
      this.context = context
      let gainNode = context.createGain() // 创建音量控制节点
      this.gainNode = gainNode
      let liveSource = context.createMediaStreamSource(stream) // 将麦克风的声音输入这个对象
      let levelChecker = context.createScriptProcessor(4096, 1, 1) // 创建一个音频分析对象，采样的缓冲区大小为4096，输入和输出都是单声道
      liveSource.connect(gainNode) // 音量控制
      gainNode.connect(levelChecker) // 将音量调节后输出到音频分析器
      levelChecker.connect(context.destination) // 最终处理结果输出到硬件设备
      this.levelChecker = levelChecker
      this.initVolume() // 初始化音量设置
      let self = this
      levelChecker.onaudioprocess = function (e) {
        let buffer = e.inputBuffer.getChannelData(0) // 获取缓冲区的输入音频， 转换为包含了PCM通道数据的32位浮点数组
        // 创建变量并迭代来获取最大的音量值
        let maxVal = 0
        for (let i = 0; i < buffer.length; i++) {
          if (maxVal < buffer[i]) {
            maxVal = buffer[i]
          }
        }
        // 显示音量值
        self.realTimeVolume = Math.round(maxVal * 100)
        self.$eventSource.emit('REALTIME_VOLUME', self.realTimeVolume)
      }
    },
    changeMicroDevice (e) {
      // 切换设备清楚之前的音频流和音频分析器
      this.localStream && this.localStream.getAudioTracks()[0].stop()
      this.levelChecker && (this.levelChecker.onaudioprocess = null)
      // this.isAudioDetect = false
      this.changingAudioDevice = true
      this.tempAudioIndex = +e.target.value
      this.getUserMedia()
    },
    changeVolume () {
      if (!this.audioStatus) return
      this.gainNode.gain.value = this.volume / 100
    },
    _resume () {
      // 关闭设置页面恢复未保存设置
      if (this.gainNode) this.initVolume()
      this.changingAudioDevice = false
      this.isMixClose = this.$store.state.audioInfo.isMixClose
    },
    _confirm () {
      console.log('================原来的设备索引========', this.selectedAudioDeviceIndex)
      console.log('================当前设备索引========', this.changedAudioDeviceIndex)
      console.log('================选择混音状态========', this.selectedMixState)
      console.log('================当前混音状态========', this.isMixClose)
      // 改变设备，关闭流
      if (this.hasPublished && this.changedAudioDeviceIndex !== this.selectedAudioDeviceIndex) {
        this.$store.commit(types.MEDIA_CAMERA_STATUS, false)
      }
      // 改变混音状态，关闭流
      if (this.hasPublished && this.selectedMixState !== this.isMixClose) {
        this.$store.commit(types.MEDIA_CAMERA_STATUS, false)
      }
      this.$store.commit(types.MEDIA_AUDIO_VOLUME, this.volume) // 当前设置音量存入vuex
      this.$store.commit(types.MEDIA_AUDIO_STATUS, this.gainNode.gain.value > 0)

      this.$store.dispatch('changeDevice', { audio: this.changedAudioDeviceIndex }) // 当前设备索引存入vuex
      this.$store.commit('CHANGE_AUDIO_MIX_STATUS', this.selectedMixState)  // 当前混音开关状态存入vuex
      window.localStorage.setItem('mix', JSON.stringify(this.selectedMixState)) // 存储用户选择结果到本地localStorage
      this.changingAudioDevice = false
      this.$store.commit(types.ALERT_STATUS, false)
    }
  }
}
</script>
